import React, { useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Title,
    FilterContainer,
    ButtonLabel,
    SurgeryIcon,
    StyledImage,
    IconContainer,
} from 'src/pages/home/component/calendarPanel/Panel.Styled';

import { HeaderContainer } from 'src/pages/home/index';

import {
    OrderPanelHeader,
    OrderContentContainer,
    Icon,
} from './OrdersHeader.styled';

//import { useSelector, useDispatch } from 'react-redux';
// Action import
// import { showOrderFilter,closeOrderFilter } from 'src/pages/orders/redux/actions';

import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import Plus from 'src/assets/images/Add.svg';
import Search from 'src/assets/images/Search.svg';
import SearchDark from 'src/assets/images/SearchDark.svg';
import FilterLight from 'src/assets/images/FilterLight.svg';
import FilterActiveLight from 'src/assets/images/FilterActiveLightNew.svg';
import FilterDark from 'src/assets/images/FilterDark.svg';
import FilterActiveDark from 'src/assets/images/FilterActiveDark.svg';
import FilterInactiveDesktop from 'src/assets/images/FilterInactiveDesktop.svg';
import SearchOrdersPanel from 'src/pages/orders/components/searchOrdersPanel/SearchOrdersPanel';
import NewOrdersPopup from 'src/pages/orders/components/ordersHeader/newOrdersPopup/NewOrdersPopup';
import OrderFilters from '../orderListFilters/OrderListFilters';

import { openFilterPopover } from 'src/pages/orders/redux/actions';
import FilterPopoverContainer from 'src/common/refactoredComponents/filter/FilterPopoverContainer';
import { getBannerHeight, logErrorToConsole } from 'src/utils/util';
import { PAGE_VISIBILITY_RULE, PROXY } from 'src/constants/appConstants';
import {
    getPageVisibilityForUser,
    getUser,
} from 'src/pages/equity/components/common/utils/eventHandlerUtil';
import { useTranslation } from 'react-i18next';
import { getConfigurations } from 'src/common/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const OrdersHeader = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    //const showFilter = useSelector((state) => state.orderListReducer?.showOrderFilter);
    const [, setShowFilter] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [openNewOrdersPopup, setOpenNewOrdersPopup] = useState(false);
    const [filterApplied, setFilterApplied] = useState(false);
    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const filterIconEl = useRef(null);
    const filterPopoverId = filterAnchorEl ? 'simple-popover' : undefined;

    const [searchAnchorEl, setSearchAnchorEl] = useState(null);
    const searchIconEl = useRef(null);
    const searchPopoverId = searchAnchorEl ? 'simple-popover' : undefined;
    const { appliedFilter, appliedView, isFilterPopoverOpen } = useSelector(
        (state) => state.orderFilterReducer
    );

    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );

    // const pageVisibilityRule = useSelector(
    //     (state) => state.pageVisibilityRuleReducer.pageRuleList
    // );

    const { appliedOrderType, appliedOrderStatus,appliedNotificationFailure } = appliedFilter;

    const enableOrderButtonBasedOnUser = () => {
        let showButton = false;
        const pageVisibilityRule = getPageVisibilityForUser(getUser());
        pageVisibilityRule.map((page) => {
            if (
                page &&
                page.pageRule.name === PAGE_VISIBILITY_RULE.name &&
                page.pageRule.rule === PAGE_VISIBILITY_RULE.rule
            ) {
                showButton = true;
            }
        });
        return showButton;
    };

    const openSearchPopOver = () => {
        setSearchAnchorEl(searchIconEl.current);
        setShowSearch((prevState) => !prevState);
    };

    const handleSearchClose = () => {
        setSearchAnchorEl(null);
        setShowSearch((prevState) => !prevState);
    };

    const openFilterPopOver = (panel) => {
        setFilterAnchorEl(filterIconEl.current);
        if (!panel) {
            dispatch(
                openFilterPopover({
                    isSet: true,
                    isShowView: true,
                    isShowFilter: false,
                })
            );
        }
        if (panel && panel.isShowView) {
            dispatch(
                openFilterPopover({
                    isSet: true,
                    isShowView: true,
                    isShowFilter: false,
                })
            );
        } else if (panel && panel.isShowFilter) {
            dispatch(
                openFilterPopover({
                    isSet: true,
                    isShowView: false,
                    isShowFilter: true,
                })
            );
        }
        setShowFilter((prevState) => !prevState);
    };

    const handleClose = () => {
        setFilterAnchorEl(null);
        //dispatch(closeOrderFilter());
        dispatch(
            openFilterPopover({
                isSet: false,
                isShowView: true,
                isShowFilter: false,
            })
        );
        setShowFilter((prevState) => !prevState);
    };

    useEffectWithErrorLogging(() => {
        let checkAppliedFilter = false;

        const checkOrderType =
            appliedOrderType.length === 0
                ? false
                : appliedOrderType.filter(
                      (x) =>
                          x.statusCode === 'ALL_ORDERTYPE' &&
                          x.isChecked === true
                  )?.length > 0
                ? false
                : true;
        const checkOrderStatus =
            appliedOrderStatus.length === 0
                ? false
                : appliedOrderStatus.filter(
                      (x) =>
                          x.statusCode === 'ALL_ORDERSTATUS' &&
                          x.isChecked === true
                  )?.length > 0
                ? false
                : true;

        checkAppliedFilter = checkOrderType || checkOrderStatus||appliedNotificationFailure?.[0]?.isChecked;

        if (props.isOrderHistory) {
            const view = appliedView || {};
            const checkAppliedView = Boolean(
                (view.appliedDistrict?.id &&
                    view.appliedDistrict.id !== 'All District') ||
                (view.appliedTerritory?.id &&
                    view.appliedTerritory.id !== 'All Territory') ||
                (view.appliedAccount?.id &&
                    view.appliedAccount.id !== 'All Account') ||
                (view.appliedOrderCondition?.id &&
                    view.appliedOrderCondition.id !== 'Assigned')
            );
            checkAppliedFilter = checkAppliedFilter || checkAppliedView;
        }

        checkAppliedFilter ? setFilterApplied(true) : setFilterApplied(false);
    }, [appliedOrderType, appliedOrderStatus, appliedView, props.isOrderHistory]);

    // useEffectWithErrorLogging(() => {
    //     if (isFilterPopoverOpen.isSet) {
    //         openFilterPopOver(isFilterPopoverOpen);
    //     }
    // }, [isFilterPopoverOpen.isSet]);

    const [calendarMarginMobile, setCalnederMarginMobile] = useState('');

    useEffectWithErrorLogging(() => {
        setCalnederMarginMobile(
            bannerHeight
                ? getBannerHeight(bannerHeight, '7.6rem !important')
                : ''
        );
    }, [bannerHeight]);

    return (
        <>
            <HeaderContainer>
                <OrderPanelHeader calnederMargin={calendarMarginMobile}>
                    <OrderContentContainer>
                        <Title>
                            {props.isOrderHistory
                                ? t('moreNavLink.orderHistoryLabel')
                                : t('orders.ordersHeader.title')}
                        </Title>
                        <FilterContainer>
                            <IconContainer ref={searchIconEl}>
                                <Icon
                                    id="orders-header-search-icon"
                                    aria-describedby={searchPopoverId}
                                    mobilePath={SearchDark}
                                    deskPath={Search}
                                    onClick={() => {
                                        try {
                                        openSearchPopOver();
                                        } catch (error) {
                                           logErrorToConsole(error);
                                        }
                                    }}
                                />
                            </IconContainer>
                            <IconContainer ref={filterIconEl}>
                                <Icon
                                    id="orders-header-filter-icon"
                                    aria-describedby={filterPopoverId}
                                    mobilePath={
                                        !filterApplied
                                            ? FilterDark
                                            : FilterActiveDark
                                    }
                                    isSearch={props.isSearch ? true : false}
                                    deskPath={
                                        !showSearch
                                            ? !filterApplied
                                                ? FilterLight
                                                : FilterActiveLight
                                            : FilterInactiveDesktop
                                    }
                                    onClick={() => {
                                        try {
                                        props.isSearch
                                            ? () => {}
                                            : openFilterPopOver();
                                            } catch (error) {
                                                logErrorToConsole(error);
                                           }
                                    }}
                                />
                            </IconContainer>
                        </FilterContainer>
                        {!props.isOrderHistory &&
                            enableOrderButtonBasedOnUser() && (
                            <Button
                            
                                id={'orders-orderheader-order-button'}
                                height={'38px'}
                                width={
                                    isLanguageChanged ? 'max-content' : '108px'
                                }
                                 variant={ButtonStyles?.surgery}
                               // surgery
                                show={true}
                                clicked={() => {
                                    try {
                                    setOpenNewOrdersPopup((prev) => !prev);
                                    dispatch(getConfigurations({ resourceType: 'visibility', module: PROXY}, PROXY));
                                    } catch (error) {
                                      logErrorToConsole(error);
                                    }
                                }}
                            >
                                <SurgeryIcon>
                                    <StyledImage src={Plus} alt="+" />
                                </SurgeryIcon>
                                <ButtonLabel style={{ marginTop: '2px' }}>
                                    {' '}
                                    {t('orders.ordersHeader.order')}
                                </ButtonLabel>
                            </Button>
                            )}
                    </OrderContentContainer>
                </OrderPanelHeader>
            </HeaderContainer>
            <FilterPopoverContainer
                popoverId={filterPopoverId}
                showPopOver={isFilterPopoverOpen.isSet}
                AnchorEl={filterAnchorEl}
                handleClose={handleClose}
                top={bannerHeight ? `${parseInt(bannerHeight) + 130}px` : '130px'}
            >
                <OrderFilters
                    firstOrderStartDate={props.firstOrderStartDate}
                    showViewPanel={isFilterPopoverOpen.isShowView}
                    showFilterPanel={isFilterPopoverOpen.isShowFilter}
                    onClose={handleClose}
                    bannerHeight={bannerHeight}
                    isOrderHistory={props.isOrderHistory}
                />
            </FilterPopoverContainer>

            <FilterPopoverContainer
                popoverId={searchPopoverId}
                showPopOver={showSearch}
                AnchorEl={searchAnchorEl}
                handleClose={handleSearchClose}
                top={bannerHeight ? `${parseInt(bannerHeight) + 130}px` : '130px'}
            >
                <SearchOrdersPanel
                    onClose={handleSearchClose}
                    showSearch={showSearch}
                    bannerHeight={bannerHeight}
                    isOrderHistory={props.isOrderHistory}
                />
            </FilterPopoverContainer>
            {/* <FilterPopover
                id={searchPopoverId}
                open={showSearch}
                anchorEl={searchAnchorEl}
                onClose={handleSearchClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                
            </FilterPopover> */}
            {openNewOrdersPopup && (
                <NewOrdersPopup
                 id="orders-ordersheader-neworderspopup"
                    onClose={() => {
                        try {
                        setOpenNewOrdersPopup((prev) => !prev);
                        } catch (error) {
                           logErrorToConsole(error);
                        }
                    }}
                />
            )}
        </>
    );
};

export default OrdersHeader;
